import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { List } from 'foundations-components/transitional/components/List';
import { ScrollContainer } from 'foundations-components/transitional/components/ScrollContainer'; // Keep the import

import { SearchResultViewTracker } from 'marketplace-ui-tracking/events/marketplace';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { LISTBOX_ID } from '../constants';
import { getOptionId } from './SearchBar';
import { SearchOption } from './SearchOption';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MAX_DROPDOWN_HEIGHT = '300px';
const StyledListItem = styled.li.withConfig({
  displayName: "SearchDropdown__StyledListItem",
  componentId: "z4bucx-0"
})(({
  theme: _theme,
  isActive
}) => {
  const theme = _theme;
  return {
    padding: theme.space['250'],
    backgroundColor: isActive ? theme.color['fill-surface-recessed'] : undefined,
    cursor: 'pointer'
  };
});
export function SearchDropdown({
  activeIndex,
  error,
  onResultSelect,
  options,
  searchTerm,
  setActiveIndex
}) {
  const [keyboardActive, setKeyboardActive] = useState(false);
  useEffect(() => {
    const handleKeyDown = e => {
      if (['ArrowUp', 'ArrowDown', 'Tab'].includes(e.key)) setKeyboardActive(true);
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);
  return /*#__PURE__*/_jsx("div", {
    onMouseMove: () => setKeyboardActive(false),
    children: /*#__PURE__*/_jsx(CardWrapper, {
      borderRadius: "200",
      insetInlineEnd: '0',
      insetInlineStart: '0',
      marginBlockStart: "100",
      maxBlockSize: MAX_DROPDOWN_HEIGHT,
      overflow: "hidden",
      position: "absolute",
      zIndex: "300",
      children: /*#__PURE__*/_jsxs(ScrollContainer, {
        maxHeight: parseInt(MAX_DROPDOWN_HEIGHT, 10),
        minBlockSize: "50px",
        children: [error && /*#__PURE__*/_jsx(ErrorMessage, {
          type: "badRequest"
        }), !error && /*#__PURE__*/_jsx(List, {
          "data-test-id": "search-results-list",
          role: "listbox",
          id: LISTBOX_ID,
          children: options.map((item, index) => {
            var _item$productTypes;
            return /*#__PURE__*/_jsx(SearchResultViewTracker, {
              componentType: "AutocompleteItem",
              resultCount: options.length,
              resultIndex: index,
              resultType: String(item.resultType),
              type: (_item$productTypes = item.productTypes) === null || _item$productTypes === void 0 ? void 0 : _item$productTypes[0],
              search: searchTerm,
              slug: item.slug,
              sourceId: item.sourceIds,
              subscreen: "search bar",
              children: /*#__PURE__*/_jsx(StyledListItem, {
                "aria-selected": activeIndex === index,
                id: getOptionId(index),
                isActive: activeIndex === index,
                onMouseMove: () => {
                  // Only set the active index if the keyboard is not active.
                  // Otherwise, when using the keyboard, the mouse will still hijack
                  // the active index whenever the scroll position changes.
                  if (!keyboardActive) setActiveIndex(index);
                },
                onClick: () => onResultSelect(item),
                role: "option",
                tabIndex: -1,
                children: /*#__PURE__*/_jsx(SearchOption, {
                  item: item,
                  searchTerm: searchTerm
                })
              })
            }, index);
          })
        })]
      })
    })
  });
}